import React from 'react';

import { Outlet } from 'react-router-dom';

import { styled, Box, Stack } from '@liscio/ui';

const Container = styled(Box)(({ theme }) => ({
  width: '100%',
  height: 'var(--liscio-app-viewport-height, 100vh)',
  '@supports (height: 100dvh)': {
    height: 'var(--liscio-app-viewport-height, 100dvh)',
  },
  backgroundColor: theme.palette.background.default,
  overflow: 'auto',
}));

const Wrapper = styled(Stack)(() => ({
  margin: 0,
  padding: 0,
}));

const AuthenticateLayout = () => (
  <Container>
    <Wrapper>
      <Outlet />
    </Wrapper>
  </Container>
);

export default AuthenticateLayout;
